module.exports = __webpack_public_path__ + "@/assets/img/trend-up.88c08a55.svg";